import { Dictionary } from 'lodash';
import moment from 'moment';
import { User } from 'api/models';
import { TimeoffResponse } from 'api/timeoff/types';
import { SchedulerEventType, TimeOffEvent } from '../../event-types';
import { resourceIdForUserAsLeaf } from '../id';
import { getSchedulerEventProps } from './common';

const convertToEvent = (timeOff: TimeoffResponse, resource): TimeOffEvent => {
  const projectId = resource.get('projectId');

  return {
    type: SchedulerEventType.UserTimeOff,
    id: `${projectId}-${timeOff.timeOffId}`,
    resourceId: resourceIdForUserAsLeaf({
      projectId,
      userId: resource.get('userId'),
      roleId: resource.get('roleId'),
      referenceTeamId: resource.get('referenceTeam')?.teamId,
    }),
    startDate: moment(timeOff.timeOffStart).startOf('day').toDate(),
    endDate: moment(timeOff.timeOffEnd).endOf('day').toDate(),
    userId: resource.get('userId'),
    timeOff,
    ...getSchedulerEventProps(SchedulerEventType.UserTimeOff, {
      cls: 'time-off-event',
    }),
  };
};

export const convertTimeOffToEvents = (
  records,
  userLookup: Dictionary<User>,
): TimeOffEvent[] => {
  const timeOffEvents: TimeOffEvent[] = [];

  records.forEach((resource) => {
    const userId = resource.get('userId');

    userLookup[userId]?.userTimeOffDetails?.forEach((timeOff) => {
      const event = convertToEvent(timeOff, resource);

      timeOffEvents.push(event);
    });
  });

  return timeOffEvents;
};
